import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';
import axios from 'axios';

export const getRequestSolicitationEditThunk = createAsyncThunk(
    `RequestSolicitationEditSlicer/getRequestSolicitationEditThunk`,
    async (solicitationId, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'Content-Type': 'application/json'
        };

        const { data } = await conciergeApiClient.get(`/Redemption/get-by-id/${solicitationId}`,
            {
                headers
            });

        return data;
    }
);

const initialState = {
    dataRequestSolicitationEdit: null,
    loadingRequestSolicitationEdit: false,
    errorRequestSolicitationEdit: false,
};

const RequestSolicitationEditSlicer = createSlice({
    name: 'requestSolicitationEdit',
    initialState,
    reducers: {
        resetDataRequestSolicitationEdit: (state) => {
            state.dataRequestSolicitationEdit = null;
            state.loadingRequestSolicitationEdit = false;
            state.errorRequestSolicitationEdit = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRequestSolicitationEditThunk.pending, (state) => {
            state.dataRequestSolicitationEdit = null;
            state.loadingRequestSolicitationEdit = true;
            state.errorRequestSolicitationEdit = false;
        });
        builder.addCase(getRequestSolicitationEditThunk.fulfilled, (state, action) => {
            state.dataRequestSolicitationEdit = action.payload;
            state.loadingRequestSolicitationEdit = false;
            state.errorRequestSolicitationEdit = false;
        });
        builder.addCase(getRequestSolicitationEditThunk.rejected, (state) => {
            state.dataRequestSolicitationEdit = null;
            state.loadingRequestSolicitationEdit = false;
            state.errorRequestSolicitationEdit = true;
        });
    },
});

export const { resetDataRequestSolicitationEdit } = RequestSolicitationEditSlicer.actions;
export default RequestSolicitationEditSlicer.reducer;